// extracted by mini-css-extract-plugin
export default {"menu_wrapper":"bulk_item_row_menu_menu_wrapper__EZmR6","menu_list_item":"bulk_item_row_menu_menu_list_item__TYEhE"};